import TrackQuery from '@/components/common/trackQuery/index'
import styles from './index.less'
import React from 'react'
class IndexPage extends React.Component {
  componentDidMount() {
  }
  render() {
    return (
      <div className={styles.main}>
        <TrackQuery />
      </div>
    )
  }

}

export default IndexPage